<template>
  <el-table
    :data="data"
    style="width: 100%"
    size="medium"
    header-row-class-name="supervision-table-header"
    row-class-name="common-table-row"
    class="is-print-hide common-table"
    border
  >
    <el-table-column prop="pharmacistName" :min-width="150" label="执业药师" />
    <el-table-column prop="storeName" :min-width="200" label="执业单位" />
    <el-table-column prop="practiceCategory" label="执业类别" :min-width="100">
      <template #default="{ row: { practiceCategory } }">
        {{ practiceCategory | adaptCategoryStatus }}
      </template>
    </el-table-column>

    <el-table-column label="注册证有效期至" :min-width="200">
      <template #default="{ row: { practiceCertDate } }">
        {{ practiceCertDate | formatTime }}
      </template>
    </el-table-column>

    <el-table-column label="注册证状态" :min-width="100">
      <template #default="{ row: { practiceCertStatus } }">
        <span :class="{ red: practiceCertStatus === 0, green: practiceCertStatus === 1 }">
          {{ practiceCertStatus | adaptPatchStatus }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="认证状态" :min-width="100">
      <template #default="{ row: { auditStatus } }">
        <span :class="{ red: auditStatus === 3, green: auditStatus === 1, yellow: auditStatus === 2 }">
          {{ auditStatus | adaptAuditStatus }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="账号状态" :min-width="100">
      <template #default="{ row: { userStatus } }">
        <span :class="{ red: userStatus === 0, green: userStatus === 1 }">
          {{ userStatus | userAdaptStatus }}
        </span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'pharmacistList',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    formatTime(val) {
      if (!val) return '--';
      return dayjs(val).format('YYYY-MM-DD');
    },
    adaptPatchStatus(val) {
      const statusMap = { 1: '正常', 0: '过期' };
      return statusMap[val] || '--';
    },
    userAdaptStatus(val) {
      const statusMap = { 1: '正常', 0: '已关闭' };
      return statusMap[val] || '--';
    },
    adaptAuditStatus(val) {
      const statusMap = { 1: '已认证', 0: '未提交', 2: '待审核', 3: '已驳回', 4: '已关闭' };
      return statusMap[val] || '--';
    },
    adaptCategoryStatus(val) {
      const statusMap = { 1: '药学', 2: '中药学', 3: '药学与中药学' };
      return statusMap[val] || '--';
    }
  }
};
</script>

<style lang="scss" scoped>
.drug-item {
  position: relative;
  padding: 5px 0;

  .drug-title {
    font-weight: 500;
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #efefef;
  }

  &:last-child {
    &:before {
      display: none;
    }
  }
}

.red {
  color: #eb3c36;
}

.green {
  color: #1e8dff;
}

.yellow {
  color: #ebb436;
}
</style>
